import React, { useState, useRef, useEffect, useLayoutEffect, useCallback } from "react";
import { useLocation } from "react-router";

import { Button, Checkbox, FormControl, FormControlLabel, Input, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";

import kutil, { type PageInfo } from "@modules/kutil";
import commonCode, { type Code } from "@modules/common_code";
import valueFormatter from "@modules/value_formatter";
import { usePopup, type PopupAction } from "@components/popup/popup_context";

interface State {
}

const defState: State = {
};

interface SearchParams {
  pns: string,
  sns: string,
  trNos: string,
  skuNoExs: string
}

const defSearchParams: SearchParams = {
  pns: "",
  sns: "",
  trNos: "",
  skuNoExs: ""
};

interface Result {
}

const defResult = {
};

function PopupSearchInput(props: any) {
  const { setOption, setActions, onClose } = usePopup();
  const [state, setState] = useState<State>(kutil.deepCopy(defState));
  const [searchParams, setSearchParams] = useState<SearchParams>(kutil.deepCopy(defSearchParams));
  const [result, setResult] = useState<Result>(kutil.deepCopy(defResult));

  const searchParamsRef = useRef(searchParams);
  const updateSearchParams = useCallback((patch: Partial<SearchParams>, isReset: boolean = false) => {
    if (isReset) {
      searchParamsRef.current = { ...patch } as SearchParams;
    } else {
      searchParamsRef.current = { ...searchParamsRef.current, ...patch };
    }
    setSearchParams(searchParamsRef.current);
    return searchParamsRef.current;
  }, []);

  // 팝업 설정
  const selectSearchParamsRef = useRef(selectSearchParams);
  selectSearchParamsRef.current = selectSearchParams;
  useLayoutEffect(() => {
    setOption({
      title: "검색어 일괄 입력",
      maxWidth: "1000px",
    });
    setActions([
      {
        id: "closePopup",
        label: "취소",
        onClick: () => onClose(),
        variant: "outlined",
      },
      {
        id: "selectSearchParams",
        label: "확인",
        onClick: () => selectSearchParamsRef.current(),
        variant: "contained",
      }
    ]);
  }, []);

  useEffect(() => {
    init();
  }, []);

  const isInit = useRef(false);
  async function init() {
    try {
      if (isInit.current == false) {
        isInit.current = await initData();
      }
      if (isInit.current) {
        await initParams();
        await doSearch();
      }
    } finally {
      kutil.setLoadingStatus(false);
    }
  }

  async function initData() {
    return true;
  }

  function toLines(csv: string) {
    return csv ? csv.split(",").join("\n") : "";
  }

  async function initParams() {
    const p = props.data?.searchParams ?? {};
    const params: SearchParams = {
      pns: toLines(p.pns),
      trNos: toLines(p.trNos),
      sns: toLines(p.sns),
      skuNoExs: toLines(p.skuNoExs),
    };
    updateSearchParams(params);
  }

  async function doSearch() {
  }

  function toCsv(text: string) {
    return text.split(/\r?\n/).map(s => s.trim()).filter(s => s !== "").join(",");
  }

  async function selectSearchParams() {
    onClose({
      isSuccess: true,
      searchParams: {
        pns: toCsv(searchParams.pns),
        sns: toCsv(searchParams.sns),
        trNos: toCsv(searchParams.trNos),
        skuNoExs: toCsv(searchParams.skuNoExs),
      },
    });
  }

  return (
    <>
      {/* 팝업 내용 */}
      <div className="popup-contents">
        {/* 검색어 일괄 입력 */}
        <div className="table-wrap">
          <table className="tbl-list">
            <colgroup>
              <col style={{ width: "25%" }} />
              <col style={{ width: "25%" }} />
              <col style={{ width: "25%" }} />
              <col style={{ width: "25%" }} />
            </colgroup>
            <tbody>
              <tr>
                <th scope="col">P/N</th>
                <th scope="col">TR No</th>
                <th scope="col">S/N</th>
                <th scope="col">SKU No</th>
              </tr>
              <tr>
                <td>
                  <TextField
                    value={searchParams.pns}
                    onChange={(e) => {updateSearchParams({ pns: e.target.value })}}
                    multiline
                    rows={15}
                    fullWidth 
                  />
                </td>
                <td>
                  <TextField
                    value={searchParams.trNos}
                    onChange={(e) => {updateSearchParams({ trNos: e.target.value })}}
                    multiline
                    rows={15}
                    fullWidth 
                  />
                </td>
                <td>
                  <TextField
                    value={searchParams.sns}
                    onChange={(e) => {updateSearchParams({ sns: e.target.value })}}
                    multiline
                    rows={15}
                    fullWidth 
                  />
                </td>
                <td>
                  <TextField
                    value={searchParams.skuNoExs}
                    onChange={(e) => {updateSearchParams({ skuNoExs: e.target.value })}}
                    multiline
                    rows={15}
                    fullWidth 
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/*// 검색어 일괄 입력 */}
      </div>
      {/*// 팝업 내용 */}
    </>
  );
}

export default React.memo(PopupSearchInput);